import axios from "axios";
import React, { useEffect, useState } from "react";
import { Constants } from "../../../CommonMethhods/Constants";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../CommonMethhods/CommonMethods";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../../Configuration/API_URL";
import SmallLoader from "../../Common/smallLoader";

function BrokerageTable() {
  const storeToken = localStorage.getItem("ssoToken");
  const [brokerageData, setBrokerageData] = useState();
  const [loader, setLoader] = useState(true);
  let clientCode = "";

  const getClientBrokerage = async (clientCode) => {
    let payloadValue = { ClientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const clientBrokerageData = await axios.post(
        DASHBOARD_CLIENT_OVERVIEW.ClientBrokerage_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(clientBrokerageData?.data);
      const resp = res.data;
      let firstElementKey = Object.keys(resp)[0];
      setBrokerageData(resp[firstElementKey]);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      getClientBrokerage(clientCode);
    }
  }, []);

  return (
    <div className="card-box brokerage-table bottom-25">
      <div className="card-title">
        <h2>{Constants.Client_Brokerage}</h2>
      </div>
      {/* {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <> */}
      {/* {summaryData == undefined || summaryData.length <= 0 ? (
                noDataFound()
              ) : (
                <> */}

      <div className="scroll-table">
        <table className="client-brokerage-table">
          <tr>
            <th rowspan="2"> Transaction Type</th>

            <th colspan="4">Equity Cash</th>
            <th colspan="4">Equity F&O</th>
          </tr>
          <tr>
            <th colspan="2">{brokerageData ? brokerageData?.type === "hni" ? Constants.Intraday_Text : Constants.Intraday : Constants.Intraday_Text}</th>
            <th colspan="2">{brokerageData ? brokerageData?.type === "hni" ? Constants.Delivery_Text : Constants.Delivery : Constants.Delivery_Text}</th>
            <th colspan="2">{brokerageData ? brokerageData?.type === "hni" ? Constants.Futures_Text : Constants.Futures : Constants.Futures_Text}</th>
            <th colspan="2">{brokerageData ? brokerageData?.type === "hni" ? Constants.Options_Text : Constants.Options : Constants.Options_Hni}</th>
          </tr>

          <tr>
            <td rowspan="2">Brokerage Rate</td>
            <td colspan="2">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.intraday ? (
                    brokerageData?.intraday.includes("P") ? (
                      <>
                        {brokerageData?.intraday.split("P")}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {brokerageData?.intraday.split("V")}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
            <td colspan="2">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.delivery ? (
                    brokerageData?.delivery.includes("P") ? (
                      <>
                        {brokerageData?.delivery.split("P")}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {brokerageData?.delivery.split("V")}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
            <td colspan="2">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.futures ? (
                    brokerageData?.futures.includes("P") ? (
                      <>
                        {brokerageData?.futures.split("P")}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {brokerageData?.futures.split("V")}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
            <td colspan="2">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.options ? (
                    brokerageData?.options.includes("P") ? (
                      <>
                        {brokerageData?.options.split("P")}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {brokerageData?.options.split("V")}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
          </tr>
        </table>
      </div>

      {/* </>
              )} */}
      {/* </>
          )} */}
    </div>
  );
}
export default BrokerageTable;
